import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, ComponentConfig, ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
//import { LocalDataSource } from 'angular2-smart-table';
import { IMG_FORMS } from './forms';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActivatedRoute, Router } from '@angular/router';
import { imageOptions } from './configoptions';
import { take } from 'rxjs';

@Component({
  selector: 'ubs-image-management',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./image-management.component.scss']
})
export class ImageManagementComponent extends BaseComponentConfig implements OnInit {
  options:ConfigOptions = {
    name:"",
    title:"Image Management Component",
    menuAndTitleOptions:{
      path:"img",
      headerTitle:"Image",
      menuItems:[],
      menuTag:"imageMenu"
  },
    listForm:new OfbizList({
      listType:"grid",
      listFormName:"ListProductCategoryMembers",
      listFormLocation:"component://kwikstore/widget/ImageManagementForms.xml",
      columnFields:this.getFields("ListProductCategoryMembers",IMG_FORMS),
      columnFieldTitles:this.getColumnFieldTitles("ListProductCategoryMembers",IMG_FORMS),
      appContext:"catalog",
      emptyListMessage:"No products found in this catalog. Use the product Manager to add products.",
      remoteFormData:{
        formData:{
          formName:"ListProductCategoryMembers",
          formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        appContext:"catalog",
        parameters:{"productCategoryId":"CATALOG1_SEARCH"}

      }
    }),
    addForm:undefined,
    findForm:undefined,
    breadCrumbData:{
      displayPrefix:"Product Galleries",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"ListProductCategoryMembers",
        "data":{
          formData:{
            formName:"ListProductCategoryMembers",
            formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
            listType:"grid"
          },
          "endPoint":""
        }
      },
      addFormText:"Create Product Gallery",
      editFormText:"Update Product Gallery"
    },
    childComponent:new ComponentConfig({
      title:"Gallery",
      listForm:new OfbizList({
        listType:"grid",
        listFormName:"ProductImages",
        listFormLocation:"component://kwikstore/widget/ImageManagementForms.xml",
        columnFields:this.getFields("ProductImages",IMG_FORMS),
        columnFieldTitles:this.getColumnFieldTitles("ProductImages",IMG_FORMS),
        appContext:"catalog",
        emptyListMessage:"No images found for this product. Use the Image Manager to add images.",
        cardMode:true,
        remoteFormData: {
          formData: {
            formName: "ProductImages",
            formLocation: "component://kwikstore/widget/ImageManagementForms.xml",
            viewIndex: 0,
            listType: "grid",
          },
          appContext: "catalog",
          parameters: { "productCategoryId": "CATALOG1_SEARCH" }
        }
      }),
      addForm:new OfbizForm({
        formName:"AddMultipleImages",
        formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
        appContext:"catalog",
        fields:this.getFields("AddMultipleImages",IMG_FORMS),
        target:this.getTarget("AddMultipleImages",IMG_FORMS),
        targets:this.getTargets("AddMultipleImages",IMG_FORMS)
      }),
      findForm:undefined,
      breadCrumbData:{
        displayPrefix:"Gallery For ",
        label:"",
        level:2,
        selectedValue:{
          "event":"list",
          "type":"ProductImages",
          "data":{
            formData:{
              formName:"ProductImages",
              formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
              listType:"grid"
            },
            "endPoint":""
          }
        },
        addFormText:"Upload Product Image",
        editFormText:"Update Product Image"
      },
      /* relations:[
        {
          title:"Manage Images",
          listFormName:"",
          addFormName:"",
          addContainerTitle:"",
          listContainerTitle:"",
          listForm:new OfbizList({
            listFormName:"ListImageManage",
            listFormLocation:"component://kwikstore/widget/ImageManagementForms.xml",
            listType:"grid",
            columnFields:this.getFields("ListImageManage",IMG_FORMS),
            columnFieldTitles:this.getColumnFieldTitles("ListImageManage",IMG_FORMS),
            appContext:"catalog",
            emptyListMessage:"No images for this product",
          }),
          addForm:new OfbizForm({}),
          keyMap:{"fieldName":"contentId"},
        },
        {
          title:"Approved Images",
          listFormName:"",
          listForm:new OfbizList({

          }),
          addFormName:"",
          addForm:new OfbizForm({}),
          listContainerTitle:"",
          addContainerTitle:"",
          keyMap:{"fieldName":"contentId"}
        },
        {
          title:"Rejected Images",
          listFormName:"",
          listForm:new OfbizList({}),
          addFormName:"",
          addForm:new OfbizForm({}),
          listContainerTitle:"",
          addContainerTitle:"",
          keyMap:{"fieldName":"contentId"}

        },
        {
          title:"Recently Approved Images",
          listFormName:"",
          listForm:new OfbizList({}),
          addFormName:"",
          addForm:new OfbizForm({}),
          listContainerTitle:"",
          addContainerTitle:"",
          keyMap:{"fieldName":"contentId"}

        },
        {
          title:"Replace Images",
          listFormName:"",
          listForm:new OfbizList({}),
          addFormName:"",
          addForm:new OfbizForm({}),
          listContainerTitle:"",
          addContainerTitle:"",
          keyMap:{"fieldName":"contentId"}

        },
        {
          title:"Resize Images",
          listFormName:"",
          listForm:new OfbizList({}),
          addFormName:"",
          addForm:new OfbizForm({}),
          listContainerTitle:"",
          addContainerTitle:"",
          keyMap:{"fieldName":"contentId"}

        }
      ] */
    }),
    settings:[],
    actions:[]
  }
  menuItems:NbMenuItem[] = [];

  firstPass = true;

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(imageOptions);
    /* baseMenuItems.forEach(item => {
      this.menuItems.push(item);
    })
    this.viewContainerService.activeMenuTag$.pipe(take(1)).subscribe(menuTag => {
      if(this.firstPass){
        this.menuService.addItems(this.menuItems,menuTag);
      }
      this.firstPass = false;
    }) */
   }

  ngOnInit(): void {
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    //let menuItems:NbMenuItem[] = [];
    
    //menuAndTitleOptions.menuItems = menuItems;
    //console.log(menuAndTitleOptions);
    //this.viewContainerService.menuAndTitleOptions$.next(menuAndTitleOptions);

    /* this.viewContainerService.activeMenuTag$.subscribe(menuTag => {
      this.menuService.addItems(menuItems,menuTag);
    }) */
    
  }

}
